import { createFileRoute } from '@tanstack/react-router';
import { SupplierContractRegister } from '../../../features/purchasing-intake/SupplierContractRegister';

/** Owned by G20 — SOLE owner of the supplier contracts screen (plan.md QC fix
 * #1). Supplier contracts register + create/edit (FLAT_WET/BDT/MOISTURE_BAND
 * with bands). */
export const Route = createFileRoute('/_authenticated/purchasing-intake/contracts')({
  component: SupplierContractRegister,
});
